document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 1000,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        pagination: {
            el: ".swiper-pagination",
            type: "fraction",
        },
        navigation: {
            nextEl: ".sw-gal-next",
            prevEl: ".sw-gal-prev",
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    

    let cards = new Swiper(".card-swiper", {
        speed: 1000,
        loop: true,
        slidesPerView: 1,
        spaceBetween: 10, 
        autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        },
        navigation: {
            nextEl: ".sw-gal-next",
            prevEl: ".sw-gal-prev",
        },

        breakpoints: {
            640: {
                slidesPerView: 1,
            },
            760: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3.8,
            }
        }
    });

    let sliderBackground = new Swiper('.slider__background', {
        loop: true,
        speed: 800,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.sw-gal-next',
            prevEl: '.sw-gal-prev'
        },
        pagination: {
            el: ".swiper-pagination",
            type: "fraction"
        }
    });

    let left__slider = new Swiper('.left__slider', {
        loop: true,
        speed: 1500,
    });

    let right__slider = new Swiper('.right__slider', {
        loop: true,
        speed: 1500,
    });

    sliderBackground.controller.control = [left__slider,right__slider];


    let gallery_home_mobile = new Swiper(".gallery-home__slider", {
        speed: 700,
        loop:true,
        effect: "fade",
        navigation: {
            nextEl: ".sw-gal-next",
            prevEl: ".sw-gal-prev",
        },
        fadeEffect: {
            crossFade: true
        }
    });
    
    let sliders = document.querySelectorAll(".single-quad-swiper");

    sliders.forEach((slider) => {
    let single_slider = new Swiper(slider, {
        loop: true,
        effect: "fade",
        fadeEffect: {
        crossFade: true,
        },
        pagination: {
            el: slider.querySelector('.single-swiper-pagination'),
            type: 'fraction'
        },
        navigation: {
            nextEl: slider.querySelector('.sw-gal-next'),
            prevEl: slider.querySelector('.sw-gal-prev'),
        },
        breakpoints: {
            320: { 
                autoHeight: true,
            }
        }
    });
    });



    let feature_events = new Swiper(".feature_events-swiper", {
        loop: true,
        effect: "fade",
         speed: 1000,
        fadeEffect: {
            crossFade: true
        },
        pagination: {
            el: ".swiper-pagination-events",
            type: "fraction"
        },
        navigation: {
            nextEl: ".sw-gal-next",
            prevEl: ".sw-gal-prev",
        }
    });

    let rooms = new Swiper(".rooms__slider", {
        speed: 1000,
        loop:true,
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".sw-gal-next",
            prevEl: ".sw-gal-prev",
        }
    });

    let quadGalleryThree = new Swiper('.gallery-default__slider', {
        speed: 700,
        loop: true,
        spaceBetween: 20,

        navigation: {
            prevEl: '.sw-gal-prev',
            nextEl: '.sw-gal-next'
        },
        breakpoints: {
            640: { 
                slidesPerView: 1 
            },
            768: { 
                slidesPerView: 2 
            },
            1024: { 
                slidesPerView: 2
            },
            1600: { 
                slidesPerView: 2.3
            }
        } 
    });
    let slider_columns = new Swiper(".slider-columns-swiper", {
        loop: true, 
        spaceBetween: 20, 
        pagination: {
            el: ".swiper-pagination",
            type: "fraction"
        },
        navigation: {
            nextEl: ".sw-gal-next",
            prevEl: ".sw-gal-prev",
        },
        breakpoints: {
            320: { 
                slidesPerView: 1, 
            },
            768: { 
                slidesPerView: 2,
            },
            1024: { 
                slidesPerView: 3,
                centeredSlides:true
            }
        }      
    });

    let slider_big = new Swiper(".big-slider-swiper", {
        loop: true, 
        spaceBetween: 20,
        slidesPerView: 1,
        pagination: {
            el: ".swiper-pagination",
            type: "fraction"
        },
        navigation: {
            nextEl: ".sw-gal-next",
            prevEl: ".sw-gal-prev",
        },    
    });
    let reviews = new Swiper(".swiper-slider-review", {
        loop: true, 
        autoplay: true,
        spaceBetween: 20, 
        speed: 3000,
        pagination: {
            el: ".swiper-pagination",
            type: "fraction"
        },
        navigation: {
            nextEl: ".sw-gal-next",
            prevEl: ".sw-gal-prev",
        },
        breakpoints: {
            640: { 
                slidesPerView: 1 
            },
            768: { 
                slidesPerView: 1 
            },
            1024: { 
                slidesPerView: 1,
                centeredSlides:true
            }
        }      
    });
});